import { render } from "./TopicsInfobar.vue?vue&type=template&id=f032c0f2"
import script from "./TopicsInfobar.vue?vue&type=script&lang=js"
export * from "./TopicsInfobar.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__